/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateTemplate.defs.js'
export { main as default } from './updateTemplate.defs.js'
